export default function modalFeedback(settings) {
  const init = import(/* webpackChunkName: "modal-feedback" */ "./init")
  const vue = import(/* webpackChunkName: "vue" */ "vue/dist/vue.runtime.esm")

  return Promise.all([vue, init]).then(([{ default: Vue }, { default: ModalFeedback }]) =>
    ModalFeedback(Vue, settings),
  )
}
